$('.product__media_right').slick({
  dots: false,
  arros:true,
  infinite: false,
  speed: 300,
  asNavFor:".product__media__left",
  slidesToShow: 1,
  slidesToScroll: 1,
});

$('.product__media__left').slick({
      slidesToShow: 6,
    slidesToScroll: 1,
    vertical:true,
    dots: false,
   arrows:false,
  asNavFor:".product__media_right",
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});



